import { createSelector } from 'redux-starter-kit';

const firmSelector = (state: any) => state.firm;

export const firmSelectors = {
  riskGroup: createSelector(firmSelector, subState => subState.riskGroup),
  displayName: createSelector(firmSelector, substate => substate.displayName),
  documentUrl: createSelector(firmSelector, substate => substate.documentUrl),
  coverImageUrl: createSelector(
    firmSelector,
    substate => substate.coverImageUrl
  ),
  riskProfiler: createSelector(firmSelector, substate => substate.riskProfiler),
  questionnaireLength: createSelector(
    firmSelector,
    substate => substate.questionnaireLength
  ),
  disclaimer: createSelector(firmSelector, substate => substate.disclaimer),
  defaultDisclaimer: createSelector(
    firmSelector,
    substate => substate.defaultDisclaimer
  )
};
